import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M5 10h14","key":"svg-0"}],["path",{"d":"M5 14h14","key":"svg-1"}],["path",{"d":"M5 19l14 -14","key":"svg-2"}]]

/**
 * IconEqualNot
 * @preview ![img](data:image/svg+xml;base64,PHN2ZwogIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICB3aWR0aD0iMjQiCiAgaGVpZ2h0PSIyNCIKICB2aWV3Qm94PSIwIDAgMjQgMjQiCiAgZmlsbD0ibm9uZSIKICBzdHJva2U9ImN1cnJlbnRDb2xvciIKICBzdHJva2Utd2lkdGg9IjIiCiAgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIgogIHN0cm9rZS1saW5lam9pbj0icm91bmQiCiAgY2xhc3M9Imljb24gaWNvbi10YWJsZXIgaWNvbnMtdGFibGVyLW91dGxpbmUgaWNvbi10YWJsZXItZXF1YWwtbm90Igo+CiAgPHBhdGggc3Ryb2tlPSJub25lIiBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIiAvPgogIDxwYXRoIGQ9Ik01IDEwaDE0IiAvPgogIDxwYXRoIGQ9Ik01IDE0aDE0IiAvPgogIDxwYXRoIGQ9Ik01IDE5bDE0IC0xNCIgLz4KPC9zdmc+) - https://tabler.io/icons/icon/equal-not
 * @see https://docs.tabler.io/icons/libraries/react - Documentation
 *
 */
const IconEqualNot = createReactComponent('outline', 'equal-not', 'EqualNot', __iconNode);

export default IconEqualNot;